<template>
    <el-form-item :label="label" :prop="prop" label-position="top">
        <VueDatePicker
            :day-names="$i18n.locale == 'kh' ? dayNameKH : dayNameEN"
            v-model="selectedTime"
            :format="format"
            :cancelText="$t('Cancel')"
            :selectText="$t('Select')"
            :is-24="is24"
            teleport-center
        />
    </el-form-item>
</template>

<script>
    import { parse, format } from 'date-fns'
    export default {
        emits: ['update:modelValue'],
        props: {
            modelValue: String,
            label: {
                type: String,
                default: 'Date Time',
            },
            is24: {
                type: Boolean,
                default: false,
            },
            prop: {
                type: String,
                default: null,
            },
            lg: {
                type: String,
                default: '12',
            },
        },
        data() {
            return {
                dayNameEN: ['M', 'T', 'W', 'TH', 'FR', 'SA', 'SU'],
                dayNameKH: ['ច', 'អ', 'ព', 'ព្រ', 'សុ', 'សៅ', 'អា'],
                selectedTime: {
                    hours: 12,
                    minutes: 0,
                },
            }
        },
        watch: {
            modelValue(newValue) {
                if (newValue) {
                    //var d = parse(newValue, 'yyyy-MM-dd HH:mm', new Date());
                    // this.selectedTime = {
                    //     hours: d.getHours(),
                    //     minutes: d.getMinutes()
                    // }
                } else {
                    this.selectedTime = {
                        hours: null,
                        minutes: null,
                    }
                    this.$emit('update:modelValue', null)
                }
            },
        },
        mounted() {
            if (this.modelValue != null) {
                const date = parse(this.modelValue, 'yyyy-MM-dd HH:mm', new Date())
                let valueDateTime = format(date, 'yyyy-MM-dd HH:mm')
                let formattedDate = format(date, 'dd-MM-yyyy hh:mm a')
                if (this.$i18n.locale == 'kh') {
                    const hour = date.getHours()
                    formattedDate = formattedDate.replace('AM', 'ព្រឹក').replace('PM', 'ថ្ងៃ')
                    if (hour >= 19 || hour < 12) {
                        // 7 PM (19:00) to 12 PM (12:00)
                        formattedDate = formattedDate.replace('ថ្ងៃ', 'យប់')
                    }
                }
                this.selectedTime = date
                this.$emit('update:modelValue', valueDateTime)
            }
        },
        methods: {
            format(date) {
                let formattedDate = format(date, 'dd-MM-yyyy hh:mm a')
                let valueDateTime = format(date, 'yyyy-MM-dd HH:mm')
                if (this.$i18n.locale == 'kh') {
                    const hour = date.getHours()
                    formattedDate = formattedDate.replace('AM', 'ព្រឹក').replace('PM', 'ថ្ងៃ')
                    if (hour >= 19 || hour < 12) {
                        // 7 PM (19:00) to 12 PM (12:00)
                        formattedDate = formattedDate.replace('ថ្ងៃ', 'យប់')
                    }
                }
                this.$emit('update:modelValue', valueDateTime)
                return formattedDate
            },
        },
    }
</script>
